import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import { SCREEN_ID_UTILITY_PROFIT_ADMIN_ORDER_HITLIST } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';

import UtilityUserActions from 'client/actions/UtilityUser';
import UtilityDealerActions from 'client/actions/UtilityDealer';
import UtilityActivationActions from 'client/actions/UtilityActivation';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import UPOrdersHitlistTable from 'client/components/UPOrdersHitlistTable/UPOrdersHitlistTable';

@withTransitionHook
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_ORDER_HITLIST)
@withScrollToTop
@branch({
  currentUser: ['utilityUser'],
  utilitySalesReps: ['utilitySalesReps', 'list'],
  utilityDealers: ['utilityDealers', 'list'],
  utilityDelayedReasons: ['utilityDelayedReasons', 'list'],
})
class UtilityProfitOrderHitlist extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Order Hitlist | Utility Profit',
  });

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    utilitySalesReps: PropTypes.array.isRequired,
    utilityDealers: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
  };

  static fetchData(state, inject) {
    const currentUser = inject.state.get('utilityUser');

    return Promise.all([
      UtilityUserActions.getSalesRepList(inject),
      UtilityDealerActions.getList(inject),
      UtilityActivationActions.getDelayedReasonsList(inject),
      UtilityActivationActions.getOrderHitlistCountBySalesRep(inject, {
        utilitySalesRepId: currentUser.id,
      }),
    ]);
  }

  render() {
    const {
      dispatch,
      currentUser,
      utilitySalesReps,
      utilityDealers,
      utilityDelayedReasons,
      match,
    } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle="Orders Dashboard"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
        maxWidth="1250px"
      >
        <UPOrdersHitlistTable
          dispatch={dispatch}
          currentUser={currentUser}
          utilitySalesReps={utilitySalesReps || []}
          utilityDealers={utilityDealers || []}
          utilityDelayedReasons={utilityDelayedReasons || []}
          orderType={match.params.orderType}
        />
      </SrPartnerPageV2>
    );
  }
}

export default UtilityProfitOrderHitlist;
